import styled from "styled-components";

export const HeroContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 40vh;
  padding-top: 5vh;
  padding-bottom: 5vh;
  background-image: linear-gradient(to left bottom, #b6c0fb, #cacdfa, #dbdaf9, #eae8f8, #f7f7f7);
  ${(props) =>
    props?.withMask && "mask: url('/roundedMaskHero.svg') center bottom / cover no-repeat;"};
`
